export default __webpack_public_path__ + "static/media/1.d1d0eabe.webp";